import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import FormsyForm from 'formsy-react'
import _assign from 'lodash/assign'
import _partial from 'lodash/partial'
import _isFunction from 'lodash/isFunction'
import Loading, { LOADING_ICON_BLUE_DARK_BG_WHITE } from '../Loading/index'
import Button, { TYPES } from '../Button/index'
import { TYPE_FORGOT_PASSWORD, TYPE_LOGIN } from '../../services/dialog/index'
import { getPasswordValidation, PASSWORD_INPUT_MAX_CHARS } from '../../services/password/index'
import { connect as staticTextConnect } from '../StaticText/connect'
import { URL_HOME } from '../../services/url/constants'
import { requestAnimationFrame } from '../../services/animate/index'
import { H1, HEADING_TYPES } from '../Heading/index'
import {
  Password as PasswordInput,
} from '../FormInput.v2/index'

function onValidSubmit (
  model,
  expiry,
  token,
  tokenType,
  uid,
  resetPassword,
  doResetPassword,
) {
  doResetPassword({
    uid,
    expiry,
    token,
    tokenType,
    newPassword: model.password,
  })

  // scroll to the top of the page on every redirect
  if (global && global.scrollTo) {
    requestAnimationFrame(() => global.scrollTo(0, 0))
  }
}

function handleClickLogin (e, props, dialogName) {
  const { onClickLogin, setOverlayDialogVisible } = props
  e.preventDefault()
  setOverlayDialogVisible(dialogName)
  if (_isFunction(onClickLogin)) {
    onClickLogin(e)
  }
}

function renderResetPasswordForm (
  props,
  canSubmit,
  setCanSubmit,
  newPassword,
  setNewPassword,
  confirmNewPassword,
  setConfirmNewPassword,
) {
  const {
    expiry,
    token,
    tokenType,
    uid,
    auth,
    resetPassword,
    doResetPassword,
    staticText,
  } = props
  const processing = resetPassword.get('processing', false)
  let message
  const success = resetPassword.getIn(['data', 'success'])
  const authToken = auth.get('jwt')

  if (!authToken && success === true) {
    message = staticText.getIn(['data', 'passwordHasBeenReset'])
  } else if (authToken && success === true) {
    message = staticText.getIn(['data', 'passwordHasBeenResetShort'])
  } else if (success === false) {
    message = staticText.getIn(['data', 'passwordResetError'])
  }

  return (
    <FormsyForm
      onValidSubmit={_partial(
        onValidSubmit,
        _partial.placeholder,
        expiry,
        token,
        tokenType,
        uid,
        resetPassword,
        doResetPassword,
      )}
      onInvalid={_partial(setCanSubmit, false)}
      onValid={_partial(setCanSubmit, true)}
    >
      {success ? null : (
        <p className="reset-password__message-item">
          {staticText.getIn(['data', 'resetPasswordMessage'])}
        </p>
      )}
      {!message ? null : (
        <p
          className={
            `reset-password__message${success === false ? ' reset-password__error' : ''}`
          }
        >
          {message}
        </p>
      )}
      {success ? null : (
        <PasswordInput
          name="password"
          label={staticText.getIn(['data', 'password'])}
          maxLength={PASSWORD_INPUT_MAX_CHARS}
          validations={_assign(
            getPasswordValidation(),
          )}
          validationErrors={{
            minLength: staticText.getIn(['data', 'passwordMinLengthMessage']),
            matchRegexp: staticText.getIn(['data', 'passwordRegexMessage']),
            maxLength: staticText.getIn(['data', 'passwordMaxLengthMessage']),
          }}
          required
          hasValidation
          value={newPassword}
          onChange={(v) => setNewPassword(v)}
          showStrength
        />
      )}
      {success ? null : (
        <PasswordInput
          name="passwordConfirm"
          label={staticText.getIn(['data', 'confirmPassword'])}
          maxLength={PASSWORD_INPUT_MAX_CHARS}
          validations={_assign(
            { equalsField: 'password' },
            getPasswordValidation(),
          )}
          validationErrors={{
            equalsField: staticText.getIn(['data', 'passwordsMustMatch']),
          }}
          required
          hasValidation
          value={confirmNewPassword}
          onChange={(v) => setConfirmNewPassword(v)}
        />
      )}
      {processing || success ? null : (
        <Button
          type={TYPES.PRIMARY}
          disabled={!canSubmit}
          submit
          stacked
          className="reset-password__button"
        >
          {staticText.getIn(['data', 'save'])}
        </Button>
      )}
      {authToken || processing || !success ? null : (
        <Button
          type={TYPES.PRIMARY}
          onClick={_partial(
            handleClickLogin,
            _partial.placeholder,
            props,
            TYPE_LOGIN,
          )}
          stacked
        >
          {staticText.getIn(['data', 'login'])}
        </Button>
      )}
      {authToken && success ? (
        <Button
          type={TYPES.PRIMARY}
          url={URL_HOME}
          stacked
        >
          {staticText.getIn(['data', 'goToGaiaHome'])}
        </Button>
      )
        : null
      }
      {!processing ? null : (
        <div className="reset-password__loading">
          <Loading visible icon={LOADING_ICON_BLUE_DARK_BG_WHITE} />
        </div>
      )}
    </FormsyForm>
  )
}

function renderResetPasswordExpired (props) {
  const { setOverlayDialogVisible, staticText } = props
  return (
    <div className="reset-password--expired">
      <p>{staticText.getIn(['data', 'resetLinkExpired'])}</p>
      <Button
        type={TYPES.PRIMARY}
        onClick={_partial(
          onClickPasswordResetExpired,
          _partial.placeholder,
          setOverlayDialogVisible,
        )}
        stacked
      >
        {staticText.getIn(['data', 'requestNewLink'])}
      </Button>
    </div>
  )
}

function onClickPasswordResetExpired (e, setOverlayDialogVisible) {
  e.preventDefault()
  setOverlayDialogVisible(TYPE_FORGOT_PASSWORD)
}

function getTitle (props) {
  const {
    serverTime, expiry, resetPassword, staticText,
  } = props
  const success = resetPassword.getIn(['data', 'success'])
  if (serverTime.getIn(['data', 'serverTime']) >= expiry) {
    return staticText.getIn(['data', 'linkExpired'])
  } if (success) {
    return staticText.getIn(['data', 'success'])
  }
  return staticText.getIn(['data', 'resetPassword'])
}

class ResetPassword extends Component {
  constructor (props) {
    super(props)
    this.state = {
      canSubmit: false,
      canRender: false,
      newPassword: '',
      confirmNewPassword: '',
    }
  }

  componentDidMount () {
    const { auth, getServerTimeData, resetResetPassword } = this.props
    getServerTimeData(auth)
    resetResetPassword()
    this.setState(() => ({ canRender: true }))
  }

  setCanSubmit = (canSubmit) => {
    this.setState(() => ({ canSubmit }))
  }

  setNewPassword = (value) => {
    this.setState(() => ({ newPassword: value }))
  }

  setConfirmNewPassword = (value) => {
    this.setState(() => ({ confirmNewPassword: value }))
  }

  render () {
    const { props } = this
    const {
      canSubmit,
      canRender,
      newPassword,
      confirmNewPassword,
    } = this.state
    const { setCanSubmit } = this
    const { expiry, serverTime } = props
    const currentServerTime = serverTime.getIn(['data', 'serverTime'])

    if (!canRender) {
      return null
    }

    if (!currentServerTime || serverTime.get('processing')) {
      return null
    }

    return (
      <div className="reset-password">
        <H1 as={HEADING_TYPES.H3} className="reset-password__title">{getTitle(props)}</H1>
        {currentServerTime < expiry
          ? renderResetPasswordForm(
            props,
            canSubmit,
            setCanSubmit,
            newPassword,
            this.setNewPassword,
            confirmNewPassword,
            this.setConfirmNewPassword,
          )
          : renderResetPasswordExpired(props)}
      </div>
    )
  }
}

ResetPassword.propTypes = {
  expiry: PropTypes.number.isRequired,
  token: PropTypes.string.isRequired,
  uid: PropTypes.number.isRequired,
  tokenType: PropTypes.string.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  serverTime: ImmutablePropTypes.map.isRequired,
  getServerTimeData: PropTypes.func.isRequired,
  onClickLogin: PropTypes.func,
  setOverlayDialogVisible: PropTypes.func.isRequired,
  doResetPassword: PropTypes.func.isRequired,
  resetResetPassword: PropTypes.func.isRequired,
  resetPassword: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

const ResetPasswordStaticText = staticTextConnect({ storeKey: 'resetPassword' })(
  ResetPassword,
)

export default ResetPasswordStaticText
